import { ReportType } from "@enums/report-type";
import { IExchangeInfo } from "@models/exchange-info.model";
import { createAction, props } from "@ngrx/store";

export const SAVE_REPORT = createAction(
  "[Reports] Save Report",
  props<{
    path: ReportType;
    intermediaryId?: string;
    exchangeInfo?: Partial<IExchangeInfo>;
    annualReportDate?: string | number;
  }>()
);
